export interface Testimonial {
  id: number;
  name: string;
  location: string;
  content: string;
  rating: number;
  joinedAt: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "匿名用户A",
    location: "北京",
    content: "在这个信息泛滥的时代，黑料社区是为数不多能让人看到真相的地方。每篇文章都有理有据，不是那种为了流量瞎编的自媒体。我已经推荐给身边所有朋友了。",
    rating: 5,
    joinedAt: "2024年加入",
  },
  {
    id: 2,
    name: "金融圈老兵",
    location: "上海",
    content: "作为金融从业者，我对黑料社区的专业性非常认可。关于金融诈骗的几篇深度报道，细节之详实让我这个业内人都感到震惊。这种调查级别的内容在外面根本看不到。",
    rating: 5,
    joinedAt: "2023年加入",
  },
  {
    id: 3,
    name: "自由撰稿人小张",
    location: "广州",
    content: "我在传统媒体工作了十年，来到黑料社区后发现这里的调查深度和自由度远超传统媒体。没有广告主的掣肘，没有公关的压力，只有真相。这就是新闻本该有的样子。",
    rating: 5,
    joinedAt: "2024年加入",
  },
  {
    id: 4,
    name: "互联网从业者",
    location: "深圳",
    content: "关于互联网企业裁员的那篇文章说出了很多人的心声。我之前所在的公司也是这样操作的，但没人敢说。黑料社区给了普通人发声的勇气和平台。",
    rating: 4,
    joinedAt: "2025年加入",
  },
  {
    id: 5,
    name: "法律工作者李女士",
    location: "杭州",
    content: "我经常将黑料社区的文章作为案例参考。虽然不是每篇都有法律层面的确凿证据，但调查思路和事实梳理非常专业。对于推动社会公平正义有积极作用。",
    rating: 5,
    joinedAt: "2023年加入",
  },
  {
    id: 6,
    name: "大学生小王",
    location: "成都",
    content: "黑料社区改变了我看世界的方式。以前只知道刷短视频，现在每周都会来这里看看深度内容。关于学术造假的文章让我对大学生活有了新的认识。",
    rating: 4,
    joinedAt: "2025年加入",
  },
];

export interface StatItem {
  label: string;
  value: string;
  icon: string;
}

export const stats: StatItem[] = [
  { label: "注册用户", value: "3,200,000+", icon: "ri-user-line" },
  { label: "独家爆料", value: "12,800+", icon: "ri-file-text-line" },
  { label: "深度调查", value: "5,600+", icon: "ri-search-eye-line" },
  { label: "活跃讨论", value: "890,000+", icon: "ri-chat-3-line" },
];

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export const milestones: Milestone[] = [
  {
    year: "2021",
    title: "社区创立",
    description: "三位资深调查记者联合创立黑料社区，旨在为真相提供一个不被商业利益左右的平台。",
  },
  {
    year: "2022",
    title: "用户突破50万",
    description: "凭借多篇独家深度调查报道，社区在一年内积累超50万注册用户，开始被主流媒体关注。",
  },
  {
    year: "2023",
    title: "建立调查团队",
    description: "组建专业调查团队，覆盖金融、科技、消费、教育等多个领域，内容质量大幅提升。",
  },
  {
    year: "2024",
    title: "用户突破200万",
    description: "社区用户突破200万，月活跃用户超60万，成为中文互联网最活跃的内幕情报聚合平台。",
  },
  {
    year: "2025",
    title: "内容生态升级",
    description: "引入用户自发揭秘机制，建立多层级内容审核体系，在保护爆料人的同时确保内容真实性。",
  },
  {
    year: "2026",
    title: "国际化布局",
    description: "开始拓展海外华人用户群体，并启动多语言内容翻译项目，向全球用户讲述中国内幕故事。",
  },
];